var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 106,
    viewBox: "0 0 174 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8281 74.3248C9.76761 77.6737 0.5 82.2358 0.5 87.2636C0.5 97.5415 39.2274 105.873 87 105.873C134.773 105.873 173.5 97.5415 173.5 87.2636C173.5 82.2358 164.232 77.6737 149.172 74.3248V82.4374C149.172 88.0815 145.604 92.7073 141.198 92.7073H32.8023C28.3962 92.7073 24.8281 88.0788 24.8281 82.4374V74.3248Z",
    fill: "#E6F4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.985 42.0117C112.985 37.7447 115.672 34.2222 119.005 34.2195H149.172V82.4374C149.172 88.0815 145.604 92.7073 141.198 92.7073H32.8023C28.3962 92.7073 24.8281 88.0788 24.8281 82.4374V34.2195H54.995C58.328 34.2195 61.0149 37.7368 61.0149 42.0037V42.0622C61.0149 46.3291 63.7315 49.7746 67.0618 49.7746H106.938C110.269 49.7746 112.985 46.2972 112.985 42.0303V42.0117Z",
    fill: "#02B9D9",
    stroke: "black",
    strokeOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.172 34.5131L121.746 3.9346C120.43 1.85031 118.508 0.59016 116.483 0.59016H57.517C55.4924 0.59016 53.5705 1.85031 52.254 3.93194L24.8281 34.5157",
    stroke: "black",
    strokeOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataImage);
export default __webpack_public_path__ + "static/media/no-data-image.c3aaac2934b44ebcd9de1b030bb9c070.svg";
export { ForwardRef as ReactComponent };